import SellerBox from './SellerBox'
export default SellerBox
